import { pageEvent, trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { EVENT_TYPE } from '@constants/enterpriseSegmentData'
import { enterpriseCommonProps } from './segmentProperties'

export const sendEnterpriseEvent = (properties = {}, eventType = EVENT_TYPE.ACTION, customWriteKey: string | null = null) => {
  if (eventType === EVENT_TYPE.VIEW) {
    return pageEvent(
      eventType,
      {
        ...enterpriseCommonProps(),
        ...properties,
      },
      customWriteKey
    )
  } else {
    return trackEvent(
      eventType,
      {
        ...enterpriseCommonProps(),
        ...properties,
      },
      customWriteKey
    )
  }
}
